<svg
    xmlns="http://www.w3.org/2000/svg"
    width="108"
    height="127"
    viewBox="0 0 108 127"
    fill="none"
>
    <path
        d="M53.9769 102.793C80.1451 102.793 101.36 81.5777 101.36 55.3155C101.36 29.0533 80.0517 7.83789 53.9769 7.83789C27.8087 7.83789 6.59375 29.0533 6.59375 55.3155C6.59375 81.5777 27.8087 102.793 53.9769 102.793Z"
        fill="#EAEEF9"
    />
    <path
        d="M98.2766 24.194C100.393 24.194 102.108 22.4784 102.108 20.3621C102.108 18.2459 100.393 16.5303 98.2766 16.5303C96.1604 16.5303 94.4448 18.2459 94.4448 20.3621C94.4448 22.4784 96.1604 24.194 98.2766 24.194Z"
        fill="#EAEEF9"
    />
    <path
        d="M103.883 9.23766C105.328 9.23766 106.5 8.06604 106.5 6.62078C106.5 5.17552 105.328 4.00391 103.883 4.00391C102.438 4.00391 101.266 5.17552 101.266 6.62078C101.266 8.06604 102.438 9.23766 103.883 9.23766Z"
        fill="#EAEEF9"
    />
    <path
        d="M9.11682 24.099C10.5621 24.099 11.7336 22.9274 11.7336 21.4821C11.7336 20.0369 10.5621 18.8652 9.11682 18.8652C7.67159 18.8652 6.5 20.0369 6.5 21.4821C6.5 22.9274 7.67159 24.099 9.11682 24.099Z"
        fill="#EAEEF9"
    />
    <g filter="url(#filter0_d_2353_6833)">
        <path
            d="M86.2204 31.5769L86.968 91.765C86.968 93.8212 85.2858 95.41 83.2297 95.41H24.5381C22.482 95.41 20.7998 93.7277 20.7998 91.765V14.3803C20.7998 12.3242 22.482 10.7354 24.5381 10.7354H67.0615L86.2204 31.5769Z"
            fill="url(#paint0_linear_2353_6833)"
        />
    </g>
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M55.1093 45.6745C54.3204 46.4353 53.0746 46.4353 52.2856 45.6745L50.8738 44.3132C49.2212 42.7198 46.9888 41.7469 44.5216 41.7469C39.4539 41.7469 35.3457 45.8746 35.3457 50.9663C35.3457 55.8478 37.9757 59.8786 41.7724 63.1904C45.5724 66.505 50.1156 68.7034 52.8301 69.8253C53.3977 70.0599 53.9972 70.0599 54.5648 69.8253C57.2793 68.7034 61.8226 66.505 65.6225 63.1904C69.4192 59.8785 72.0492 55.8478 72.0492 50.9663C72.0492 45.8746 67.941 41.7469 62.8733 41.7469C60.4062 41.7469 58.1737 42.7198 56.5212 44.3132L55.1093 45.6745ZM53.6975 41.3568C51.316 39.0606 48.0829 37.6494 44.5216 37.6494C37.2016 37.6494 31.2676 43.6116 31.2676 50.9663C31.2676 64.0134 45.4807 71.2184 51.2787 73.6147C52.8402 74.2601 54.5548 74.2601 56.1163 73.6147C61.9143 71.2183 76.1274 64.0134 76.1274 50.9663C76.1274 43.6116 70.1933 37.6494 62.8733 37.6494C59.3121 37.6494 56.0789 39.0606 53.6975 41.3568Z"
        fill="#D5DDEA"
    />
    <path
        d="M49.3984 83.352H47.2488C46.7815 83.352 46.4077 82.8847 46.4077 82.324C46.4077 81.7632 46.7815 81.2959 47.2488 81.2959H49.3984C49.8657 81.2959 50.2395 81.7632 50.2395 82.324C50.2395 82.9782 49.8657 83.352 49.3984 83.352Z"
        fill="#CED7E2"
    />
    <path
        d="M42.8557 83.352H30.3323C29.865 83.352 29.4912 82.8847 29.4912 82.324C29.4912 81.7632 29.865 81.2959 30.3323 81.2959H42.8557C43.323 81.2959 43.6968 81.7632 43.6968 82.324C43.6968 82.9782 43.323 83.352 42.8557 83.352Z"
        fill="#D5DDEA"
    />
    <path
        d="M58.837 23.3518H30.7062C30.052 23.3518 29.4912 22.7911 29.4912 22.1369C29.4912 21.4826 30.052 20.9219 30.7062 20.9219H58.837C59.4912 20.9219 60.052 21.4826 60.052 22.1369C60.052 22.7911 59.4912 23.3518 58.837 23.3518Z"
        fill="#D5DDEA"
    />
    <path
        d="M41.5473 30.0813H30.7062C30.052 30.0813 29.4912 29.5206 29.4912 28.8663C29.4912 28.2121 30.052 27.6514 30.7062 27.6514H41.4538C42.108 27.6514 42.6688 28.2121 42.6688 28.8663C42.6688 29.5206 42.108 30.0813 41.5473 30.0813Z"
        fill="#D5DDEA"
    />
    <path
        d="M67.061 10.7324V27.3683C67.061 29.7048 69.1171 31.574 71.4536 31.574H86.2199"
        fill="#D5DDEA"
    />
    <path
        d="M98.5636 106C98.0974 106 97.6313 105.812 97.2584 105.388L89.474 97.5201L89.1943 97.7085C86.6772 99.5929 83.7406 100.582 80.7573 100.582C77.1681 100.582 73.5789 99.1218 70.9219 96.5779C68.1251 93.8926 66.5869 90.265 66.5869 86.3077C66.5869 78.4403 72.9263 72.0332 80.7107 72.0332C86.0246 72.0332 90.6859 74.8598 93.2031 79.6651C95.6736 84.4233 95.3473 89.9824 92.3174 94.4579L92.131 94.7405L99.962 102.655C100.754 103.456 100.568 104.257 100.428 104.681C100.055 105.435 99.3094 106 98.5636 106ZM80.7107 75.9434C75.0239 75.9434 70.4558 80.6073 70.4558 86.3077C70.4558 92.809 75.7231 96.7192 80.8506 96.7192C83.9736 96.7192 86.817 95.3059 88.8214 92.7619C91.2919 89.6526 91.7114 85.4597 89.9867 81.8322C88.2154 78.2047 84.6728 75.9434 80.7107 75.9434Z"
        fill="#989FB0"
    />
    <defs>
        <filter
            id="filter0_d_2353_6833"
            x="0.238848"
            y="0.454873"
            width="107.29"
            height="125.797"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
            />
            <feOffset dy="10.2805" />
            <feGaussianBlur stdDeviation="10.2805" />
            <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
            />
            <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_2353_6833"
            />
            <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_2353_6833"
                result="shape"
            />
        </filter>
        <linearGradient
            id="paint0_linear_2353_6833"
            x1="53.8624"
            y1="8.77675"
            x2="53.8624"
            y2="96.3228"
            gradientUnits="userSpaceOnUse"
        >
            <stop stop-color="#FDFEFF" />
            <stop offset="0.9964" stop-color="#ECF0F5" />
        </linearGradient>
    </defs>
</svg>
